module.exports = "/_next/static/images/018e647f5719ea30cc8e2fd31d385969-apple-pay-md.png";